
















import { FieldScheme, InputFieldType }    from "@/components/pageGenerator/models";
import { Component, Prop, PropSync, Vue } from "vue-property-decorator";

@Component({
  name      : "ValidatableCheckbox",
  components: {}
})
export default class ValidatableCheckbox extends Vue {
  private InputFieldType = InputFieldType;

  @Prop({
    required: true,
    type    : Object as () => FieldScheme,
    default : {}
  })
  private field!: FieldScheme;

  @PropSync("value")
  private valueSynced!: unknown;
}
